// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.copied-leave-active[data-v-5a98aa05] {\n  transition: opacity 1s ease;\n}\n.copied-leave-to[data-v-5a98aa05] {\n  opacity: 0;\n}\n.border-gray[data-v-5a98aa05] {\n  border-color: gray !important;\n}\n", ""]);
// Exports
module.exports = exports;
